import * as devisConf from '@/configuration/devisConf';

export default function genererLigneRemise() {
  return {
    typeRemise: devisConf.TYPE_REMISE_FRONT_REMISE_POURCENTAGE,
    selected: false,
    type: devisConf.TYPE_REMISE_CASCADE,
    ordre: 0,
    libelle: '',
    montant: 0,
    remise: 0,
    isRemiseRegie: false,
  };
}
